var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup265(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(-309 -3076)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(309 3076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "youtube-svgrepo-com",
    transform: "translate(316.164 3085.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M15.109,67.393H3.961A3.973,3.973,0,0,0,0,71.378v5.608a3.973,3.973,0,0,0,3.961,3.985H15.109a3.973,3.973,0,0,0,3.961-3.985V71.378A3.973,3.973,0,0,0,15.109,67.393Zm-2.678,7.062-5.215,2.5a.209.209,0,0,1-.3-.19V71.606a.209.209,0,0,1,.3-.188l5.215,2.659A.211.211,0,0,1,12.431,74.455Z",
    transform: "translate(0 -67.393)",
    fill: "#123374"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup265);
export default __webpack_public_path__ + "static/media/Group 265.f746ce202b0196171e960224a76bfdea.svg";
export { ForwardRef as ReactComponent };